export default "__VITE_PUBLIC_ASSET__fe25ec0a__"